import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiResponse, ProviderAllowedModule, ProviderAccessCheck } from '@core/types';

@Injectable({
  providedIn: 'root',
})
export class ProviderAccessService {
  private readonly baseUrl = `${environment.api}/provider-access`;

  constructor(private httpClient: HttpClient) {}

  getAllowedModules(): Observable<ApiResponse<ProviderAllowedModule[]>> {
    return this.httpClient
      .get<ApiResponse<ProviderAllowedModule[]>>(`${this.baseUrl}/modules`)
      .pipe(
        catchError((errorResponse: HttpErrorResponse) =>
          throwError(() => `${errorResponse.error.message}`)
        )
      );
  }

  checkAccess(moduleCode: string): Observable<ApiResponse<ProviderAccessCheck>> {
    return this.httpClient
      .post<ApiResponse<ProviderAccessCheck>>(`${this.baseUrl}/check`, { moduleCode })
      .pipe(
        catchError((errorResponse: HttpErrorResponse) =>
          throwError(() => `${errorResponse.error.message}`)
        )
      );
  }
}
